import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vShow as _vShow, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "text-end"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-circle-up" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-circle-down" }, null, -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "text-end"
}
const _hoisted_12 = { class: "fw-bold" }
const _hoisted_13 = {
  key: 3,
  colspan: "4"
}
const _hoisted_14 = {
  key: 0,
  class: "edit-row"
}
const _hoisted_15 = ["colspan"]
const _hoisted_16 = {
  key: 0,
  class: "d-flex justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _component_EmergencyContactsForm = _resolveComponent("EmergencyContactsForm")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass(_ctx.isContactFormOpen || _ctx.isDeleteRequested ? 'edit-row' : '')
    }, [
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.contact.firstName
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.contact.lastName
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, { text: _ctx.primaryPhoneNumber }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, { text: _ctx.relationshipValue }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.contact.email
        }, null, 8 /* PROPS */, ["text"])
      ]),
      (!_ctx.isContactFormOpen && !_ctx.isDeleteRequested && !_ctx.isReOrderRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              type: "button",
              class: "btn table-btn btn-outline-info",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showContactForm(true)))
            }, _hoisted_3)), [
              [_directive_tooltip, { title: `Edit Contact` }]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              type: "button",
              class: "btn table-btn btn-outline-danger",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.requestDeleteContact()))
            }, _hoisted_5)), [
              [_directive_tooltip, { title: `Delete Contact` }]
            ]),
            (!_ctx.contact.isPrimary)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  type: "button",
                  class: "ps-1 text-decoration-none",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.makeEmergencyContactPrimary()))
                }, " Make Primary "))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isReOrderRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              type: "button",
              class: "btn table-btn btn-outline-info",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.moveUp(_ctx.index)))
            }, _hoisted_8)), [
              [_directive_tooltip, { title: `Move Contact Up` }],
              [_vShow, _ctx.contact.contactOrder !== 0]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              type: "button",
              class: "btn table-btn btn-outline-info",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.moveDown(_ctx.index)))
            }, _hoisted_10)), [
              [_directive_tooltip, { title: `Move Contact Down` }],
              [_vShow, _ctx.contact.contactOrder !== _ctx.totalContacts - 1]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isContactFormOpen)
        ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
            _createElementVNode("i", _hoisted_12, _toDisplayString(_ctx.isEditRequested ? "Editing In Progress" : "View In Progress"), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
            _createVNode(_component_TablePrompt, {
              "ok-text": "delete",
              name: "Delete",
              "is-in-progress": _ctx.isDeleteInProgress,
              ok: _ctx.deleteContact,
              cancel: _ctx.cancelDeleteContact
            }, null, 8 /* PROPS */, ["is-in-progress", "ok", "cancel"])
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createCommentVNode(" Editing "),
    (_ctx.isContactFormOpen)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-3"
          }, [
            _createVNode(_component_EmergencyContactsForm, {
              ref: "contactForm",
              onUpdateIsEditing: _ctx.updateIsEditing,
              "is-loading": _ctx.isSaving,
              "relationships-enum": _ctx.relationshipsEnum,
              "contact-roles-enum": _ctx.contactRolesEnum,
              "cahps-survey-contact-enum": _ctx.cahpsSurveyContactEnum,
              "is-palliative": _ctx.isPalliative,
              contact: _ctx.contactCopy,
              "patient-primary-address": _ctx.patientPrimaryAddress,
              "is-editable": _ctx.isEditRequested,
              "patient-id": _ctx.patientId,
              "total-contacts": _ctx.totalContacts,
              "cahps-survey-recipient-index": _ctx.cahpsSurveyRecipientIndex,
              "close-contact-form": _ctx.closeContactForm,
              "refresh-list": _ctx.refreshList,
              referral: _ctx.referral
            }, null, 8 /* PROPS */, ["onUpdateIsEditing", "is-loading", "relationships-enum", "contact-roles-enum", "cahps-survey-contact-enum", "is-palliative", "contact", "patient-primary-address", "is-editable", "patient-id", "total-contacts", "cahps-survey-recipient-index", "close-contact-form", "refresh-list", "referral"]),
            (!_ctx.isSaving)
              ? (_openBlock(), _createElementBlock("footer", _hoisted_16, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary me-2 mb-2",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveContact()))
                  }, "Save"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary mb-2",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeContactForm()))
                  }, "Cancel")
                ]))
              : _createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_15)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}